import React, {useState, useEffect} from "react";
import {
  apollo_useStyles,
  Option,
} from "../atom/Apollo_styles_Beta";
import {
  options_setpoint_columns,
} from "../atom/Apollo_Options";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import MUIDataTable, {MUIDataTableProps} from "mui-datatables";
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';

import {LineChart} from "../pages/SUMMARY/LineChart_Beta";
import {BarChart} from "../pages/SUMMARY/BarChart";
import {
  ChartData,
  ALL,
  INIT_YEAR_DATE,
  DEMOGRAPHIC_COLUMNS,
  SUMMARY_GRAPH_HEADERS,
  SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS,
} from "../common/Apollo_CommonConst_Beta";

import moment from 'moment'
import {LinearProgress, TableCell, TableFooter, TableRow} from "@material-ui/core";
import * as colors from "@material-ui/core/colors";
import {
  NumberOption,
} from "../atom/Apollo_Options";
import {DailyPerformance, DemographicPerformance} from "../pages/SUMMARY/SummaryModel";

type ApolloPerformanceProps = MUIDataTableProps & {
  startDate: string;
  endDate: string;
  previousStartDate: string;
  previousEndDate: string;
  dailyPerformanceData: DailyPerformance[][];
  previousDailyPerformanceData: DailyPerformance[][];
  demographicPerformanceData?: DemographicPerformance[][];
  selectedValues?: string[];
  chartPtn?: number;
  storageKeyGraph1: string;
  storageKeyGraph2: string;
  storageKeyDemographicGraph?: string;
  fileName?: string;
  histogramFileName?: string;
  loadingChart?: boolean;
  onLoadChart?: any;
  isAutoDisplayChecked?: boolean;
  setIsAutoDisplayChecked?: any;
  isPreviousPeriodChecked: boolean;
  setIsPreviousPeriodChecked: any;
  isPreviousPeriodDisabled?: boolean;
  isChartDataLoaded: boolean;
  demographicDisplayPeriod?: number;
  setDemographicDisplayPeriod?: any;
  statementFlag?: boolean;
  setPoints?: Option[],
  referenceDate?: string,
}

// 実績値カラム
const AchievementValue = {
  Cost: "cost",
  Imp: "imp",
  Vimp: "vimp",
  Click: "click",
  Ctr: "ctr",
  Vctr: "vctr",
  Cpc: "cpc",
  Cpm: "cpm",
  TrackingPointCvTotal: "trackingPointCvTotal",
  TrackingPointCvClickThrough: "trackingPointCvClickThrough",
  TrackingPointCvClickThroughSetPoints: "trackingPointCvClickThroughSetPoints",
  TrackingPointCvAssist: "trackingPointCvAssist",
  TrackingPointCvAssistSetPoints: "trackingPointCvAssistSetPoints",
  TrackingPointCpaTotal: "trackingPointCpaTotal",
  TrackingPointCpaClickThrough: "trackingPointCpaClickThrough",
  TrackingPointCpaClickThroughSetPoints: "trackingPointCpaClickThroughSetPoints",
  TrackingPointCpaAssist: "trackingPointCpaAssist",
  TrackingPointCvrTotal: "trackingPointCvrTotal",
  TrackingPointCvrClickThrough: "trackingPointCvrClickThrough",
  TrackingPointCvrClickThroughSetPoints: "trackingPointCvrClickThroughSetPoints",
  TrackingPointCvrAssist: "trackingPointCvrAssist",
  LastCvTotal: "lastCvTotal",
  // LastCvClickThrough: "lastCvClickThrough",
  // LastCvAssist: "lastCvAssist",
  LastCpaTotal: "lastCpaTotal",
  // LastCpaClickThrough: "lastCpaClickThrough",
  // LastCpaAssist: "lastCpaAssist",
  LastCvrTotal: "lastCvrTotal",
  // LastCvrClickThrough: "lastCvrClickThrough",
  // LastCvrAssist: "lastCvrAssist",
} as const;
type AchievementValue = typeof AchievementValue[keyof typeof AchievementValue];

export const ApolloPerformance: React.FC<ApolloPerformanceProps> = ({
                                                                      startDate,
                                                                      endDate,
                                                                      previousStartDate,
                                                                      previousEndDate,
                                                                      // chartRawData,
                                                                      dailyPerformanceData,
                                                                      previousDailyPerformanceData,
                                                                      demographicPerformanceData,
                                                                      selectedValues,
                                                                      data,
                                                                      columns,
                                                                      options,
                                                                      title,
                                                                      chartPtn,
                                                                      storageKeyGraph1,
                                                                      storageKeyGraph2,
                                                                      storageKeyDemographicGraph,
                                                                      fileName,
                                                                      histogramFileName,
                                                                      loadingChart,
                                                                      onLoadChart,
                                                                      isAutoDisplayChecked,
                                                                      setIsAutoDisplayChecked,
                                                                      isPreviousPeriodChecked,
                                                                      setIsPreviousPeriodChecked,
                                                                      isPreviousPeriodDisabled,
                                                                      isChartDataLoaded,
                                                                      demographicDisplayPeriod,
                                                                      setDemographicDisplayPeriod,
                                                                      statementFlag,
                                                                      setPoints,
                                                                      referenceDate,
                                                                    }) => {
  
  // const exeCount = useRef(1);
  // console.log("■■■ ApolloPerformance inner start :" + exeCount.current)
  
  const classes = apollo_useStyles();
  const fixedHeightPaper = clsx(classes.summarypaper, classes.fixedHeightGraph);
  const fixedHeightGrid = clsx(classes.summarypaper, classes.fixedHeightGrid);

  const _demographicPerformanceData = demographicPerformanceData ? demographicPerformanceData : [];
  const mergedSetPoints = setPoints ? setPoints : [];

  const [chartData, setChartData] = useState<ChartData>(generateInitGraphData(mergedSetPoints))
  const [previousChartData, setPreviousChartData] = useState<ChartData>(generateInitGraphData(mergedSetPoints))
  const [demographicChartData, setDemographicChartData] = useState<ChartData>(generateInitDemographicGraphData(mergedSetPoints))
  const [filteredIndexes, setFilteredIndexes] = useState<number[]>([])

  const [chartRenderId, setChartRenderId] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number | undefined>(options?.rowsPerPage)

  const rawDataToChartData = (dailyPerformanceData: DailyPerformance[][], startDate: string, endDate: string, filteredIndexes: number[]): ChartData => {
    let chartData: Array<[string, ...number[]]> = []
    let outputChartData: ChartData = []

    const currentDateMoment = moment(startDate).startOf('day')
    const endDateMoment = moment(endDate).startOf('day')

    if (
      dailyPerformanceData.length === 0
      || filteredIndexes.length === 0
      || endDateMoment.diff(currentDateMoment, 'days') + 1 !== dailyPerformanceData[0].length
    ) {
      outputChartData.push([INIT_YEAR_DATE, ...Array<number>(SUMMARY_GRAPH_HEADERS.length-1+(options_setpoint_columns.length*mergedSetPoints.length)).fill(0)])
    } else {
      while (true) {
        chartData.push([currentDateMoment.clone().format('YYYY-MM-DD'), ...Array<number>(SUMMARY_GRAPH_HEADERS.length-1+(options_setpoint_columns.length*mergedSetPoints.length)).fill(0)]);
        if (currentDateMoment.add(1, 'days').diff(endDateMoment) > 0) {
          break
        }
      }

      // テーブルのチェックされた行のデータのみ抽出
      let filteredRawData:DailyPerformance[][] = [];
      if (!selectedValues || selectedValues.includes(ALL)) {
        filteredRawData = dailyPerformanceData.filter((ele, index) => filteredIndexes.includes(index))
      } else {
        filteredRawData = dailyPerformanceData.filter((ele, index) => filteredIndexes.includes(index) && selectedValues.includes(String(index)))
      }

      // テーブルの行ごとにループ
      for (let i = 0; i < filteredRawData.length; i++) {
        let dailyPerformances = filteredRawData[i]

        if (chartData.length !== dailyPerformances.length) {
          continue
        }

        // 日付ごとにループ
        for (let j = 0; j < dailyPerformances.length; j++) {
          chartData[j][1] += dailyPerformances[j].cost
          chartData[j][2] += dailyPerformances[j].imp
          chartData[j][3] += dailyPerformances[j].vimp
          chartData[j][4] += dailyPerformances[j].click
          chartData[j][9] += dailyPerformances[j].trackingPointCvTotal
          chartData[j][10] += dailyPerformances[j].trackingPointCvClickThrough
          chartData[j][11] += dailyPerformances[j].trackingPointCvAssist
          chartData[j][18] += dailyPerformances[j].lastCvTotal

          let chartIndex:number = SUMMARY_GRAPH_HEADERS.length;
          for (let index = 0; index < mergedSetPoints.length; index++) {
            if (dailyPerformances[j].trackingPointCvClickThroughSetPoints) {
              const targetItem = dailyPerformances[j].trackingPointCvClickThroughSetPoints.find((item) => item.id === mergedSetPoints[index].value);
              if (targetItem) {
                chartData[j][chartIndex] = Number(chartData[j][chartIndex]) + targetItem.value;
              }
            }
            chartIndex++
          }
          for (let index = 0; index < mergedSetPoints.length; index++) {
            if (dailyPerformances[j].trackingPointCvAssistSetPoints) {
              const targetItem = dailyPerformances[j].trackingPointCvAssistSetPoints.find((item) => item.id === mergedSetPoints[index].value);
              if (targetItem) {
                chartData[j][chartIndex] = Number(chartData[j][chartIndex]) + targetItem.value;
              }
            }
            chartIndex++
          }
        }
      }

      // ctr, cvr, cpaなどの割合の算出
      // 日付ごとにループ
      for (let j = 0; j < chartData.length; j++) {
        // クリック率
        chartData[j][5] = Number.parseFloat((chartData[j][4] / chartData[j][2] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][5])) chartData[j][5] = 0;

        // ビュークリック率
        chartData[j][6] = Number.parseFloat((chartData[j][4] / chartData[j][3] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][6])) chartData[j][6] = 0;

        // 平均CPC
        chartData[j][7] = (Math.round(chartData[j][1] / chartData[j][4])) || 0
        if (!isFinite(chartData[j][7])) chartData[j][7] = 0;

        // CPM
        chartData[j][8] = (Math.round(chartData[j][1] / chartData[j][2] * 1000)) || 0
        if (!isFinite(chartData[j][8])) chartData[j][8] = 0;

        // 計測ポイントCVR(total)
        chartData[j][12] = Number.parseFloat((chartData[j][9] / chartData[j][4] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][12])) chartData[j][12] = 0;

        // 計測ポイントCVR(ラストクリック)
        chartData[j][13] = Number.parseFloat((chartData[j][10] / chartData[j][4] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][13])) chartData[j][13] = 0;

        // 計測ポイントCVR(アシスト)
        chartData[j][14] = Number.parseFloat((chartData[j][11] / chartData[j][4] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][14])) chartData[j][14] = 0;

        // 計測ポイントCPA(total)
        chartData[j][15] = (Math.trunc(chartData[j][1] / chartData[j][9])) || 0
        if (!isFinite(chartData[j][15])) chartData[j][15] = 0;

        // 計測ポイントCPA(ラストクリック)
        chartData[j][16] = (Math.trunc(chartData[j][1] / chartData[j][10])) || 0
        if (!isFinite(chartData[j][16])) chartData[j][16] = 0;

        // 計測ポイントCPA(アシスト)
        chartData[j][17] = (Math.trunc(chartData[j][1] / chartData[j][11])) || 0
        if (!isFinite(chartData[j][17])) chartData[j][17] = 0;

        // 最終CVR(total)
        chartData[j][19] = Number.parseFloat((chartData[j][18] / chartData[j][4] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][19])) chartData[j][19] = 0;

        // 最終CPA(total)
        chartData[j][20] = (Math.trunc(chartData[j][1] / chartData[j][18])) || 0
        if (!isFinite(chartData[j][20])) chartData[j][20] = 0;

        let chartIndex:number = SUMMARY_GRAPH_HEADERS.length+(2*mergedSetPoints.length);
        for (let index = 0; index < mergedSetPoints.length; index++) {
          chartData[j][chartIndex] = Number.parseFloat((Number(chartData[j][SUMMARY_GRAPH_HEADERS.length+index]) / chartData[j][4] * 100).toFixed(2)) / 100 || 0
          if (!isFinite(Number(chartData[j][chartIndex]))) chartData[j][chartIndex] = 0;
          chartIndex++
        }
        for (let index = 0; index < mergedSetPoints.length; index++) {
          chartData[j][chartIndex] = (Math.trunc(chartData[j][1] / Number(chartData[j][SUMMARY_GRAPH_HEADERS.length+index]))) || 0
          if (!isFinite(Number(chartData[j][chartIndex]))) chartData[j][chartIndex] = 0;
          chartIndex++
        }
      }

      outputChartData = chartData
    }

    // ヘッダーを先頭に追加
    outputChartData.unshift([...SUMMARY_GRAPH_HEADERS, ...generateSetPointColumns(mergedSetPoints)])
    return outputChartData
  }

  const demographicDataToChartData = (demographicPerformance: DemographicPerformance[][], filteredIndexes: number[]): ChartData => {
    let chartData: Array<[string, string, ...number[]]> = []
    let outputChartData: ChartData = []

    for (const gender of DEMOGRAPHIC_COLUMNS.GENDER) {
      for (const ageRange of DEMOGRAPHIC_COLUMNS.AGE_RANGE) {
        chartData.push([ageRange, gender, ...Array<number>(SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS.length-2+(options_setpoint_columns.length*mergedSetPoints.length)).fill(0)])
      }
    }

    if (
      demographicPerformance.length > 0
      && filteredIndexes.length > 0) {

      // チェックされた行のデータのみ抽出
      let filteredRawData:DemographicPerformance[][] = [];
      if (!selectedValues || selectedValues.includes(ALL)) {
        filteredRawData = demographicPerformance.filter((ele, index) => filteredIndexes.includes(index))
      } else {
        filteredRawData = demographicPerformance.filter((ele, index) => filteredIndexes.includes(index) && selectedValues.includes(String(index)))
      }

      // テーブルの行ごとにループ
      for (let i = 0; i < filteredRawData.length; i++) {
        let performances = filteredRawData[i]

        // 年齢幅、性別ごとにループ
        for (let j = 0; j < performances.length; j++) {
          chartData[j][2] += performances[j].cost
          chartData[j][3] += performances[j].imp
          chartData[j][4] += performances[j].vimp
          chartData[j][5] += performances[j].click
          chartData[j][10] += performances[j].trackingPointCvTotal
          chartData[j][11] += performances[j].trackingPointCvClickThrough
          chartData[j][12] += performances[j].trackingPointCvAssist

          let chartIndex:number = SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS.length;
          for (let index = 0; index < mergedSetPoints.length; index++) {
            const targetItem = performances[j].trackingPointCvClickThroughSetPoints.find((item) => item.id === mergedSetPoints[index].value);
            if (targetItem) {
              chartData[j][chartIndex] = Number(chartData[j][chartIndex]) + targetItem.value;
            }
            chartIndex++
          }
          for (let index = 0; index < mergedSetPoints.length; index++) {
            const targetItem = performances[j].trackingPointCvAssistSetPoints.find((item) => item.id === mergedSetPoints[index].value);
            if (targetItem) {
              chartData[j][chartIndex] = Number(chartData[j][chartIndex]) + targetItem.value;
            }
            chartIndex++
          }
        }
      }

      // ctr, cvr, cpaなどの割合の算出
      // 年齢幅、性別ごとにループ
      for (let j = 0; j < chartData.length; j++) {
        // クリック率
        chartData[j][6] = Number.parseFloat((chartData[j][5] / chartData[j][3] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][6])) chartData[j][6] = 0;

        // ビュークリック率
        chartData[j][7] = Number.parseFloat((chartData[j][5] / chartData[j][4] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][7])) chartData[j][7] = 0;

        // 平均CPC
        chartData[j][8] = (Math.round(chartData[j][2] / chartData[j][5])) || 0
        if (!isFinite(chartData[j][8])) chartData[j][8] = 0;

        // CPM
        chartData[j][9] = (Math.round(chartData[j][2] / chartData[j][3] * 1000)) || 0
        if (!isFinite(chartData[j][9])) chartData[j][9] = 0;

        // 計測ポイントCVR(total)
        chartData[j][13] = Number.parseFloat((chartData[j][10] / chartData[j][5] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][13])) chartData[j][13] = 0;

        // 計測ポイントCVR(ラストクリック)
        chartData[j][14] = Number.parseFloat((chartData[j][11] / chartData[j][5] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][14])) chartData[j][14] = 0;

        // 計測ポイントCVR(アシスト)
        chartData[j][15] = Number.parseFloat((chartData[j][12] / chartData[j][5] * 100).toFixed(2)) / 100 || 0
        if (!isFinite(chartData[j][15])) chartData[j][15] = 0;

        // 計測ポイントCPA(total)
        chartData[j][16] = (Math.trunc(chartData[j][2] / chartData[j][10])) || 0
        if (!isFinite(chartData[j][16])) chartData[j][16] = 0;

        // 計測ポイントCPA(ラストクリック)
        chartData[j][17] = (Math.trunc(chartData[j][2] / chartData[j][11])) || 0
        if (!isFinite(chartData[j][17])) chartData[j][17] = 0;

        // 計測ポイントCPA(アシスト)
        chartData[j][18] = (Math.trunc(chartData[j][2] / chartData[j][12])) || 0
        if (!isFinite(chartData[j][18])) chartData[j][18] = 0;

        let chartIndex:number = SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS.length+(2*mergedSetPoints.length);
        for (let index = 0; index < mergedSetPoints.length; index++) {
          chartData[j][chartIndex] = Number.parseFloat((Number(chartData[j][SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS.length+index]) / chartData[j][5] * 100).toFixed(2)) / 100 || 0
          if (!isFinite(Number(chartData[j][chartIndex]))) chartData[j][chartIndex] = 0;
          chartIndex++
        }
        for (let index = 0; index < mergedSetPoints.length; index++) {
          chartData[j][chartIndex] = (Math.trunc(chartData[j][2] / Number(chartData[j][SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS.length+index]))) || 0
          if (!isFinite(Number(chartData[j][chartIndex]))) chartData[j][chartIndex] = 0;
          chartIndex++
        }
      }
    }

    outputChartData = chartData
    outputChartData.unshift([...SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS, ...generateSetPointColumns(mergedSetPoints)])

    return outputChartData
  }

  // 実績値フォーマット
  function formatVal(val: string) {
    let replaceVal: string = val;
    if (replaceVal.indexOf("¥") != -1) {
      replaceVal = replaceVal.replace(/¥/g, "");
    }
    if (replaceVal.indexOf(",") != -1) {
      replaceVal = replaceVal.replace(/,/g, "");
    }

    return parseFloat(replaceVal);
  }

  // カラムのインデックス取得
  function getIndex(opt: any, colName: string) {
    const colIndex = opt.columns.reduce((num: number, value: any, index: number) => {
      if (value.name === colName) {
        num = index;
      }
      return num;
    }, 0);

    return colIndex;
  }

  function getIndexArray(opt: any, colName: string) {
    let colIndexArray: number[] = opt.columns.reduce((nums: number[], value: any, index: number) => {
      if (value.name === colName) {
        nums.push(index);
      }
      return nums;
    }, []);

    return colIndexArray;
  }

  // カラム 表示/非表示 取得
  function getIsDisplay(opt: any, colIndex: number) {
    let isDisplay: boolean = false;
    if (colIndex > 0) {
      isDisplay = opt.columns[colIndex].display;
    }

    return isDisplay;
  }

  // 実績値合計
  function getTotalVal(opt: any, colName: string) {
    const colIndex = getIndex(opt, colName);
    let isDisplay: boolean = getIsDisplay(opt, colIndex);
    let totalVal: number = 0;

    if (isDisplay) {
      totalVal = opt.data.reduce(function (sum: number, element: any) {
        return sum + formatVal(element.data[colIndex]);
      }, 0);
    }

    return Math.floor(totalVal);
  }

  function getTotalValArray(opt: any, colName: string) {
    const totalArray: NumberOption[] = [];
    const colIndexArray = getIndexArray(opt, colName);

    for (const colIndex of colIndexArray) {
      let isDisplay: boolean = getIsDisplay(opt, colIndex);
      let totalVal: number = 0;

      if (isDisplay) {
        totalVal = opt.data.reduce(function (sum: number, element: any) {
          return sum + formatVal(element.data[colIndex]);
        }, 0);
      }

      let val: NumberOption = {
        value: colIndex,
        label: Math.floor(totalVal),
      }
      totalArray.push(val);
    }

    return totalArray;
  }

  // 合計CPA計算
  function calcCpa(val1: any, val2: any) {
    let totalCpa: number = 0;

    if (val1 !== 0 && val2 !== 0) {
      totalCpa = Math.trunc(val1 / val2);
    }

    return totalCpa;
  }

  function calcCpaArray(opt: any, colName: string, displayColName: string, total: number) {
    const totalArray: NumberOption[] = [];
    const colIndexArray = getIndexArray(opt, colName);
    const displayColIndex = getIndexArray(opt, displayColName);

    for (var i = 0; i < colIndexArray.length; i++) {
      let totalVal: number = 0;
      let totalCpa: number = 0;

      totalVal = opt.data.reduce(function (sum: number, element: any) {
        return sum + formatVal(element.data[colIndexArray[i]]);
      }, 0);

      if (total !== 0 && totalVal !== 0) {
        totalCpa = Math.trunc(total / totalVal);
      }

      let val: NumberOption = {
        value: displayColIndex[i],
        label: totalCpa,
      }
      totalArray.push(val);
    }

    return totalArray;
  }

  // 実績値平均
  function getAverageVal(val1: any, val2: any) {
    let averageVal: string = "0.00%";

    if (val1 !== 0 && val2 !== 0) {
      averageVal = (Math.round((val1 / val2 * 100) * 100) / 100).toFixed(2) + "%"
    }

    return averageVal;
  }

  function getAverageValArray(opt: any, colName: string, displayColName: string, total: number) {
    const totalArray: Option[] = [];
    const colIndexArray = getIndexArray(opt, colName);
    const displayColIndex = getIndexArray(opt, displayColName);

    for (var i = 0; i < colIndexArray.length; i++) {
      let totalVal: number = 0;
      let averageVal: string = "0.00%";

      totalVal = opt.data.reduce(function (sum: number, element: any) {
        return sum + formatVal(element.data[colIndexArray[i]]);
      }, 0);

      if (totalVal !== 0 && total !== 0) {
        averageVal = (Math.round((totalVal / total * 100) * 100) / 100).toFixed(2) + "%"
      }

      let val: Option = {
        value: displayColIndex[i],
        label: averageVal,
      }
      totalArray.push(val);
    }

    return totalArray;
  }

  /** 合計CPC計算 */
  function calcCpc(cost: any, click: any) {
    let totalCpc: number = 0;

    if (cost !== 0 && click !== 0) {
      totalCpc = Math.round(cost / click);
    }

    return totalCpc;
  }

  /** 合計CPM計算 */
  function calcCpm(cost: any, imp: any) {
    let totalCpm: number = 0;

    if (cost !== 0 && imp !== 0) {
      totalCpm = Math.round(cost / imp * 1000);
    }

    return totalCpm;
  }


  function getMuiTheme() {
    return createMuiTheme({
      palette: {
        primary: {
          main: colors.blue[300],
          light: '#fff',
          contrastText: '#fff',
        },
      },
      overrides: {
        MuiPaper: {
          root: {
            //width: "100%"
            //maxWidth: "100px",
          }
        },
        MuiPopover: {
          paper: {
            Width: "300px",
          }
        },
        MuiDialog: {
          paperFullWidth: {
            maxWidth: "inherit",
            transform: "initial",
            content: "center"
          },
          root: {
            Width: "100px",
            transform: "initial",
            content: "center"
          },
          container: {
            maxWidth: "100px",
          }
        },
        MuiToolbar: {
          root: {
            maxWidth: "inherit",
            variant: "regular"
            //   width: "100%",
          }
        },
        MuiTableCell: {
          root: {
            //padding: '4 4 4 4',
            padding: "none",
          },
        },
        MuiTableRow: {
          root: {},
          hover: {
            //cursor: "grab"
          },
        },
      }
    })
  }

  function getLineTheme() {
    return createMuiTheme({
      palette: {
        primary: {
          light: '#01c54e',
          main: '#01c450',
          dark: '#00c250',
          contrastText: '#01c94c',
        },
      },
    })
  }

  useEffect(() => {
    if (!chartData) {
      setFilteredIndexes([])
      setChartRenderId((value) => value + 1)
    } else {
      setFilteredIndexes(data ? data.map((v, i) => i) : []);
      setChartRenderId((value) => value + 1)
    }
  }, [dailyPerformanceData])

  useEffect(() => {
    if (typeof options?.rowsPerPage === "number") {
      setRowsPerPage(options.rowsPerPage)
    }
  }, [options?.rowsPerPage])

  useEffect(() => {

    setChartData(rawDataToChartData(dailyPerformanceData, startDate, endDate, filteredIndexes))
    setPreviousChartData(rawDataToChartData(previousDailyPerformanceData, previousStartDate, previousEndDate, filteredIndexes))
    setDemographicChartData(demographicDataToChartData(_demographicPerformanceData, filteredIndexes))
    setChartRenderId(chartRenderId + 1)
  }, [filteredIndexes])

  // 一覧の「Rows per page」等を変更した際に、一覧上部に自動スクロールさせる
  const scrollRef = React.createRef<HTMLDivElement>()

  // console.log("■■■ ApolloPerformance inner end :" + exeCount.current)
  // exeCount.current = exeCount.current + 1

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={demographicDisplayPeriod !== undefined?6:12}>
          <Paper className={fixedHeightPaper} square variant="outlined">
            <LineChart startDate={startDate} endDate={endDate}
                       previousStartDate={previousStartDate} previousEndDate={previousEndDate}
                       inputData={chartData} previousInputData={previousChartData}
                       key={`${chartRenderId}`} chartPtn={chartPtn}
                       storageKeyGraph1={storageKeyGraph1} storageKeyGraph2={storageKeyGraph2}
                       fileName={fileName} loadingChart={loadingChart} onLoadChart={onLoadChart}
                       isAutoDisplayChecked={isAutoDisplayChecked} setIsAutoDisplayChecked={setIsAutoDisplayChecked}
                       isPreviousPeriodChecked={isPreviousPeriodChecked} setIsPreviousPeriodChecked={setIsPreviousPeriodChecked}
                       isPreviousPeriodDisabled={isPreviousPeriodDisabled}
                       isChartDataLoaded={isChartDataLoaded}
                       setPoints={mergedSetPoints}
            />
            {loadingChart &&
            <ThemeProvider theme={getLineTheme()}>
                <LinearProgress color="primary"/>
            </ThemeProvider>
            }
          </Paper>
        </Grid>
        {demographicDisplayPeriod && storageKeyDemographicGraph && referenceDate &&
          <Grid item xs={6}>
            <Paper className={fixedHeightPaper} square variant="outlined">
              <BarChart inputData={demographicChartData}
                        key={`${chartRenderId}`} chartPtn={chartPtn}
                        storageKeyGraph={storageKeyDemographicGraph}
                        fileName={histogramFileName}
                        demographicDisplayPeriod={demographicDisplayPeriod} setDemographicDisplayPeriod={setDemographicDisplayPeriod}
                        statementFlag={statementFlag}
                        setPoints={mergedSetPoints}
                        referenceDate={referenceDate}
              />
            </Paper>
          </Grid>
        }
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper className={fixedHeightGrid} square variant="outlined">
            <div className={classes.tableScrollContainer} ref={scrollRef}>
              <ThemeProvider theme={getMuiTheme()}>
                <MUIDataTable
                  title={title}
                  data={data ? data : []}
                  columns={columns}
                  options={
                    {
                      ...options,
                      rowsPerPage: rowsPerPage ?? options?.rowsPerPage,
                      tableId: "apollo_performance",
                      textLabels: {
                        body: {noMatch: "該当データが存在しません"}
                      },
                      fixedHeader: true,
                      pagination: true,
                      tableBodyMaxHeight: "90vh",
                      selectableRows: "none",
                      selectableRowsHideCheckboxes: true,
                      onChangeRowsPerPage: (numberOfRows: number) => {
                        setRowsPerPage(numberOfRows)
                        if (options?.onChangeRowsPerPage) {
                          options.onChangeRowsPerPage(numberOfRows);
                        }
                        // RowsPerPages変更時に一覧上部に自動スクロールさせる
                        // 再レンダリングさせるために、setTimeoutを使用
                        setTimeout(() => {
                          scrollRef?.current?.scrollIntoView();
                        }, 0);
                      },
                      onChangePage: (currentPage: number) => {
                        const element = document.querySelectorAll("[data-tableid=apollo_performance]")
                        if (element.length > 0) {
                          const divEle = element[0].closest("div");
                          if (divEle) divEle.scrollTo(divEle.scrollLeft, 0)
                        }
                        if (options?.onChangePage) {
                          options.onChangePage(currentPage);
                        }
                        // Page変更時に一覧上部に自動スクロールさせる
                        // 再レンダリングさせるために、setTimeoutを使用
                        setTimeout(() => {
                          scrollRef?.current?.scrollIntoView();
                        }, 0);
                      },
                      onRowSelectionChange: (currentRowSelected, allRowSelected, rowSelected) => {
                        setFilteredIndexes(rowSelected ? rowSelected : [])
                      },
                      rowsSelected: filteredIndexes,
                      customTableBodyFooterRender: function (opts) {
                        const sumCost = getTotalVal(opts, AchievementValue.Cost);
                        const sumImp = getTotalVal(opts, AchievementValue.Imp);
                        const sumVimp = getTotalVal(opts, AchievementValue.Vimp);
                        const sumClick = getTotalVal(opts, AchievementValue.Click);
                        const aveCtr = getAverageVal(sumClick, sumImp);
                        const aveVctr = getAverageVal(sumClick, sumVimp);
                        const sumCpc = calcCpc(sumCost, sumClick);
                        const sumCpm = calcCpm(sumCost, sumImp);
                        const sumTrackingPointCvTotal = getTotalVal(opts, AchievementValue.TrackingPointCvTotal);
                        const sumTrackingPointCvClickThrough = getTotalVal(opts, AchievementValue.TrackingPointCvClickThrough);
                        const sumTrackingPointCvClickThroughSetPoints = getTotalValArray(opts, AchievementValue.TrackingPointCvClickThroughSetPoints);
                        const sumTrackingPointCvAssist = getTotalVal(opts, AchievementValue.TrackingPointCvAssist);
                        const sumTrackingPointCvAssistSetPoints = getTotalValArray(opts, AchievementValue.TrackingPointCvAssistSetPoints);
                        const sumTrackingPointCpaTotal = calcCpa(sumCost, sumTrackingPointCvTotal);
                        const sumTrackingPointCpaClickThrough = calcCpa(sumCost, sumTrackingPointCvClickThrough);
                        const sumTrackingPointCpaClickThroughSetPoints = calcCpaArray(opts, AchievementValue.TrackingPointCvClickThroughSetPoints, AchievementValue.TrackingPointCpaClickThroughSetPoints, sumCost);
                        const sumTrackingPointCpaAssist = calcCpa(sumCost, sumTrackingPointCvAssist);
                        const aveTrackingPointCvrTotal = getAverageVal(sumTrackingPointCvTotal, sumClick);
                        const aveTrackingPointCvrClickThrough = getAverageVal(sumTrackingPointCvClickThrough, sumClick);
                        const aveTrackingPointCvrClickThroughSetPoints = getAverageValArray(opts, AchievementValue.TrackingPointCvClickThroughSetPoints, AchievementValue.TrackingPointCvrClickThroughSetPoints, sumClick);
                        const aveTrackingPointCvrAssist = getAverageVal(sumTrackingPointCvAssist, sumClick);
                        const sumLastCvTotal = getTotalVal(opts, AchievementValue.LastCvTotal);
                        const sumLastCpaTotal = calcCpa(sumCost, sumLastCvTotal);
                        const aveLastCvrTotal = getAverageVal(sumLastCvTotal, sumClick);

                        return (
                          <TableFooter>
                            <TableRow>
                              {opts.selectableRows !== 'none' ? <TableCell/> : null}
                              {opts.columns.map((col, index) => {
                                if (col.display === undefined || col.display === 'false' || col.display === 'excluded') {
                                  return null;
                                }

                                if (col.name === AchievementValue.Cost) {
                                  return (<TableCell key={index}>{"¥" + sumCost.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.Imp) {
                                  return (<TableCell key={index}>{sumImp.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.Vimp) {
                                  return (<TableCell key={index}>{sumVimp.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.Click) {
                                  return (<TableCell key={index}>{sumClick.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.Ctr) {
                                  return (<TableCell key={index}>{aveCtr.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.Vctr) {
                                  return (<TableCell key={index}>{aveVctr.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.Cpc) {
                                  return (<TableCell key={index}>{"¥" + sumCpc.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.Cpm) {
                                  return (<TableCell key={index}>{"¥" + sumCpm.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.TrackingPointCvTotal) {
                                  return (
                                    <TableCell key={index}>{sumTrackingPointCvTotal.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.TrackingPointCvClickThrough) {
                                  return (<TableCell
                                    key={index}>{sumTrackingPointCvClickThrough.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.TrackingPointCvClickThroughSetPoints) {
                                  const foundOption = sumTrackingPointCvClickThroughSetPoints.find(option => option.value === index);
                                  if (foundOption) {
                                    return (<TableCell
                                      key={index}>{foundOption.label.toLocaleString()}</TableCell>);
                                  }
                                } else if (col.name === AchievementValue.TrackingPointCvAssist) {
                                  return (
                                    <TableCell key={index}>{sumTrackingPointCvAssist.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.TrackingPointCvAssistSetPoints) {
                                  const foundOption = sumTrackingPointCvAssistSetPoints.find(option => option.value === index);
                                  if (foundOption) {
                                    return (<TableCell
                                      key={index}>{foundOption.label.toLocaleString()}</TableCell>);
                                  }
                                } else if (col.name === AchievementValue.TrackingPointCpaTotal) {
                                  return (<TableCell
                                    key={index}>{"¥" + sumTrackingPointCpaTotal.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.TrackingPointCpaClickThrough) {
                                  return (<TableCell
                                    key={index}>{"¥" + sumTrackingPointCpaClickThrough.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.TrackingPointCpaClickThroughSetPoints) {
                                  const foundOption = sumTrackingPointCpaClickThroughSetPoints.find(option => option.value === index);
                                  if (foundOption) {
                                    return (<TableCell
                                      key={index}>{"¥" + foundOption.label.toLocaleString()}</TableCell>);
                                  }
                                } else if (col.name === AchievementValue.TrackingPointCpaAssist) {
                                  return (<TableCell
                                    key={index}>{"¥" + sumTrackingPointCpaAssist.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.TrackingPointCvrTotal) {
                                  return (
                                    <TableCell key={index}>{aveTrackingPointCvrTotal.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.TrackingPointCvrClickThrough) {
                                  return (<TableCell
                                    key={index}>{aveTrackingPointCvrClickThrough.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.TrackingPointCvrClickThroughSetPoints) {
                                  const foundOption = aveTrackingPointCvrClickThroughSetPoints.find(option => option.value === index);
                                  if (foundOption) {
                                    return (<TableCell
                                      key={index}>{foundOption.label.toLocaleString()}</TableCell>);
                                  }
                                } else if (col.name === AchievementValue.TrackingPointCvrAssist) {
                                  return (
                                    <TableCell key={index}>{aveTrackingPointCvrAssist.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.LastCvTotal) {
                                  return (<TableCell key={index}>{sumLastCvTotal.toLocaleString()}</TableCell>);
                                // } else if (col.name === AchievementValue.LastCvClickThrough) {
                                //   return (<TableCell key={index}>{sumLastCvClickThrough.toLocaleString()}</TableCell>);
                                // } else if (col.name === AchievementValue.LastCvAssist) {
                                //   return (<TableCell key={index}>{sumLastCvAssist.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.LastCpaTotal) {
                                  return (<TableCell key={index}>{"¥" + sumLastCpaTotal.toLocaleString()}</TableCell>);
                                // } else if (col.name === AchievementValue.LastCpaClickThrough) {
                                //   return (
                                //     <TableCell key={index}>{"¥" + sumLastCpaClickThrough.toLocaleString()}</TableCell>);
                                // } else if (col.name === AchievementValue.LastCpaAssist) {
                                //   return (<TableCell key={index}>{"¥" + sumLastCpaAssist.toLocaleString()}</TableCell>);
                                } else if (col.name === AchievementValue.LastCvrTotal) {
                                  return (<TableCell key={index}>{aveLastCvrTotal.toLocaleString()}</TableCell>);
                                // } else if (col.name === AchievementValue.LastCvrClickThrough) {
                                //   return (<TableCell key={index}>{aveLastCvrClickThrough.toLocaleString()}</TableCell>);
                                // } else if (col.name === AchievementValue.LastCvrAssist) {
                                //   return (<TableCell key={index}>{aveLastCvrAssist.toLocaleString()}</TableCell>);
                                } else {
                                  return <TableCell key={index}/>;
                                }
                              })}
                            </TableRow>
                          </TableFooter>
                        );
                      }
                    }
                  }
                />
              </ThemeProvider>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

const generateInitGraphData = (setPoints: Option[]): ChartData => {
  let outputChartData: ChartData = []
  outputChartData.push([INIT_YEAR_DATE, ...Array<number>(SUMMARY_GRAPH_HEADERS.length-1+(options_setpoint_columns.length*setPoints.length)).fill(0)])
  outputChartData.unshift([...SUMMARY_GRAPH_HEADERS, ...generateSetPointColumns(setPoints)])

  return outputChartData;
};

const generateSetPointColumns = (setPoints: Option[]): string[] => {
  var local_setpoint_columns: string[] = []
  for (let column of options_setpoint_columns) {
    for (let setpoint of setPoints) {
      local_setpoint_columns.push(`${column.label}(${setpoint.label})`);
    }
  }
  return local_setpoint_columns;
};

const generateInitDemographicGraphData = (setPoints: Option[]): ChartData => {
  let outputChartData: ChartData = []
  for (const gender of DEMOGRAPHIC_COLUMNS.GENDER) {
    for (const ageRange of DEMOGRAPHIC_COLUMNS.AGE_RANGE) {
      outputChartData.push([ageRange, gender, ...Array<number>(SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS.length-2+(options_setpoint_columns.length*setPoints.length)).fill(0)])
    }
  }

  outputChartData.unshift([...SUMMARY_DEMOGRAPHIC_GRAPH_HEADERS, ...generateSetPointColumns(setPoints)])

  return outputChartData;
};

export default ApolloPerformance
